import { Calendar, CircleDashed, User } from 'lucide-react';
import { useMemo } from 'react';

import { type FilterChipOption, type FilterToolbarSchema, UNSET } from '@/components/composed';

import { Identifier } from '../../common/utils/user-identifier';
import { AffiliateApplicationStatus } from './domain/affiliate-application-types';

const STATUS_OPTIONS: FilterChipOption[] = [
  { value: UNSET, label: 'All statuses' },
  { value: AffiliateApplicationStatus.Pending, label: 'Pending', color: '#F79009' },
  { value: AffiliateApplicationStatus.Approved, label: 'Approved', color: '#10B981' },
  { value: AffiliateApplicationStatus.Rejected, label: 'Rejected', color: '#F04438' },
  { value: AffiliateApplicationStatus.OnHold, label: 'On Hold', color: '#6B7280' },
];

const isValidIdentifier = (value: string): boolean => Boolean(Identifier.fromString(value)?.isValid());

export const useAffiliateApplicationsFiltersSchema = (): FilterToolbarSchema =>
  useMemo<FilterToolbarSchema>(
    () => ({
      chips: [
        { name: 'status', type: 'select', label: 'Status', icon: CircleDashed, options: STATUS_OPTIONS },
        {
          name: 'user_identifier',
          type: 'address',
          label: 'User identifier',
          icon: User,
          placeholder: 'Address or email',
          validate: isValidIdentifier,
        },
      ],
      date: {
        name: 'date',
        type: 'date-range',
        icon: Calendar,
        label: 'Date range',
        fromKey: 'from',
        toKey: 'to',
        enableTime: true,
      },
    }),
    [],
  );
